<template>
  <v-app-bar clipped-left clipped-right app dense dark style="z-index: 4;">
    <img
      src="../assets/SefLinkPlusLogo.svg"
      alt="SEF Link Plus logo"
      :onclick="goToHome()"
      style="cursor: pointer;"
    />
    <v-toolbar-title link @click="goToHome()" style="cursor:pointer;" class="ml-2 mt-1 black--text font-weight-bold">Izveštaji</v-toolbar-title>
    <v-spacer />
    <v-btn class="button-class" @click="logout()" v-if="this.$store.getters.isLoggedIn === true">
      Log out
      <v-icon>mdi-logout</v-icon>
    </v-btn>
  </v-app-bar>
</template>


<style scoped>
header  {
  /* background: linear-gradient('#D199FB', '#BA66F9') */
  background: linear-gradient(0.25turn, #D199FB, #AF49A8);
}
</style>

<script>
export default {
  name: 'Toolbar',
  methods: {
    logout () {
      this.$store.commit('token', null)
      this.goToHome()
    },
    goToHome () {
      if (this.$router.currentRoute.path !== '/') {
        this.$router.push('/')
        return
      }

      if (this.$store.getters.isLoggedIn === false
        && this.$router.currentRoute.path !== '/login') {
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
.button-class{
  margin-left: 10px;
  margin-right: 10px;
}
</style>
